import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { HeaderComponent } from '../header/header.component';
import { DetailViewWrapperComponent } from '../detail-view-wrapper/detail-view-wrapper.component';
import { HomepageComponent } from '../homepage/homepage.component';
import { ContextMenuComponent } from '../context-menu/context-menu.component';
import { SidenavComponent } from '../sidenav/sidenav.component';
import { FilterDrawerComponent } from '../filter-drawer/filter-drawer.component';
import { Footer } from '../footer/footer';


@Component({
  selector: 'app-detail-context-wrapper',
  templateUrl: './detail-context-wrapper.component.html',
  styleUrls: ['./detail-context-wrapper.component.scss'],
  standalone: true,
  imports: [
    HeaderComponent,
    DetailViewWrapperComponent,
    HomepageComponent,
    ContextMenuComponent,
    SidenavComponent,
    FilterDrawerComponent,
    Footer,
    RouterOutlet
]
})
export class DetailContextWrapperComponent implements OnInit {
  isAdminRoute: boolean = false;

  constructor(private router: Router) {}

  ngOnInit(): void {
    // Check if we're on admin route initially
    this.isAdminRoute = this.router.url.includes('/admin');
    
    // Subscribe to route changes
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.isAdminRoute = this.router.url.includes('/admin');
    });
  }
}
